import { ReactNode } from 'react';
import { Stack } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RemindingTone } from '../../../../api/gql';
import { FormInput, FormInputProps } from '../../../../components/form/FormInput';
import { FormSelect, FormSelectProps } from '../../../../components/form/FormSelect';
import { getRemindingToneTransKey } from '../../../../utils/invoice';
import { ConnectedFormFieldGroup } from '../connected/ConnectedFormFieldGroup';

type Props = {
  control: Control<any>;
  slots?: { actionArea?: ReactNode; afterContact?: ReactNode; end?: ReactNode };
  readonly?: boolean;
  inputProps?: Partial<FormInputProps & FormSelectProps>;
};

export const CustomerFormPart = ({ inputProps, control, slots, readonly }: Props) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2} mt={1} px={0} py={2}>
      <Grid xs={12} md={6}>
        <FormInput
          {...inputProps}
          readonly={readonly}
          control={control}
          name={'customer.vatId'}
          label={t('vatId') + ' *'}
        />
      </Grid>
      {slots?.actionArea ? (
        <Grid xs={12} md={6}>
          {slots.actionArea}
        </Grid>
      ) : null}
      <Grid xs={12} md={slots?.actionArea ? 12 : 6}>
        <FormInput {...inputProps} readonly={readonly} control={control} name={'customer.taxId'} label={t('taxId')} />
      </Grid>
      <Grid xs={12}>
        <FormInput
          {...inputProps}
          readonly={readonly}
          control={control}
          name={'customer.name'}
          label={t('businessName') + '*'}
        />
      </Grid>
      <Grid xs={12}>
        <FormInput
          {...inputProps}
          readonly={readonly}
          control={control}
          multiline={true}
          minRows={3}
          name={'customer.address'}
          label={t('streetAddress')}
        />
      </Grid>
      <Grid xs={12} md={12}>
        <ConnectedFormFieldGroup
          required={true}
          readonly={readonly}
          label={t('contactInfo')}
          helperText={t('contactInfo.helperText') as string}
          formNames={['customer.email', 'customer.phone']}
        >
          <Stack spacing={2}>
            <FormInput
              {...inputProps}
              readonly={readonly}
              control={control}
              name={'customer.email'}
              label={t('email')}
              disableRequiredErrorIndication
            />
            <FormInput
              {...inputProps}
              readonly={readonly}
              control={control}
              name={'customer.phoneNumber'}
              label={t('phone')}
              disableRequiredErrorIndication
            />
          </Stack>
        </ConnectedFormFieldGroup>
      </Grid>
      {slots?.afterContact ? (
        <Grid xs={12} paddingTop={0}>
          {slots.afterContact}
        </Grid>
      ) : null}
      <Grid xs={12}>
        <FormSelect
          {...inputProps}
          readonly={readonly}
          control={control}
          name={'customer.remindingTone'}
          options={Object.values(RemindingTone).map((tone) => ({
            label: t(getRemindingToneTransKey(tone)),
            value: tone,
          }))}
          label={t('remindingTone.title')}
        />
      </Grid>
      {slots?.end ? (
        <Grid xs={12} paddingTop={0}>
          {slots.end}
        </Grid>
      ) : null}
    </Grid>
  );
};
